/* SHADY_DYNAMIC_CHECKOUT_GUARD
 * Prevent a stale accelerated checkout button from surviving a variant change
 * when Shopify Collective reports CONTINUE for a zero-stock variant.
 */
(() => {
  if (window.__shadyOversoldGuardV2Initialized) return;
  window.__shadyOversoldGuardV2Initialized = true;

  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      window.setTimeout(start, 50);
      return;
    }

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const productInfo = data?.event?.target?.closest?.('product-info');
      const dynamicCheckout = productInfo?.querySelector?.('[id^="DynamicCheckout-"]');
      dynamicCheckout?.classList.add('hidden');
    });

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const html = data?.html;
      const sectionId = data?.sectionId;
      if (!html || !sectionId) return;

      const source = html.getElementById(`DynamicCheckout-${sectionId}`);
      if (!source) return;

      document.querySelectorAll('product-info').forEach((productInfo) => {
        if (productInfo.dataset.section !== sectionId && productInfo.dataset.originalSection !== sectionId) return;

        const destination = productInfo.querySelector('[id^="DynamicCheckout-"]');
        if (!destination) return;

        const shouldShow = !source.classList.contains('hidden') && source.innerHTML.trim().length > 0;

        if (typeof HTMLUpdateUtility !== 'undefined') {
          HTMLUpdateUtility.setInnerHTML(destination, source.innerHTML);
        } else {
          destination.innerHTML = source.innerHTML;
        }

        destination.classList.toggle('hidden', !shouldShow);
        if (shouldShow && window.Shopify?.PaymentButton?.init) {
          window.Shopify.PaymentButton.init();
        }
      });
    });
  };

  start();
})();
